import { createFileRoute } from "@tanstack/react-router";
import { DomainsPage } from "../../features/settings/domains";

export const Route = createFileRoute("/_authed/$org/team/domains")({ component: Page });

function Page() {
  return <DomainsPage org={Route.useParams().org} />;
}
